import * as React from 'react';

import { LocationViewModel } from 'models';

import { UitkIcon } from 'uitk-react-icons';

export interface LocationSummaryProps {
  locations: LocationViewModel[];
}

export class LocationSummary extends React.PureComponent<LocationSummaryProps> {
  public render() {
    const { locations } = this.props;
    if (!locations || locations.length === 0) {
      return null;
    }

    const locationSummary =
      locations &&
      locations.map((location, index) => {
        const { accessibleCategory, category, distance, name } = location;
        const categoryIconName = category === 'flight' ? 'lob_flights' : category;

        return (
          <li className="location-summary__list-item" data-stid="location-summary" key={`location-${index}`}>
            <UitkIcon id={`whats-around-property-location-category-${index}`} name={categoryIconName} title={accessibleCategory} />
            <dl className="uitk-grid all-cell-1-2">
              <dt className="location-summary__name uitk-cell all-cell-fill all-r-padding-two">{name}</dt>
              <dd className="location-summary__distance uitk-cell all-cell-shrink">{distance}</dd>
            </dl>
          </li>
        );
      });

    return <ul className="uitk-type-list-300 location-summary__list icon-s">{locationSummary}</ul>;
  }
}
